import React from 'react';

export interface CardProps {
  children?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Card: React.FC<CardProps> = ({
  children,
  header,
  footer,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  footerClassName = '',
  onClick,
}) => {
  return (
    <div
      className={`
        bg-white rounded-lg shadow-md overflow-hidden
        transition-shadow duration-300 hover:shadow-lg
        ${className}
      `}
      onClick={onClick}
    >
      {header && (
        <div
          className={`
            px-6 py-4 border-b border-gray-200 bg-gray-50
            ${headerClassName}
          `}
        >
          {header}
        </div>
      )}

      <div className={`px-6 py-4 ${bodyClassName}`}>
        {children}
      </div>

      {footer && (
        <div
          className={`
            px-6 py-4 border-t border-gray-200 bg-gray-50
            ${footerClassName}
          `}
        >
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
